import React from 'react';
import cx from 'classnames';
import './Error.css';
import logo from '../assets/images/SHDRLogo@2x.png';

function Error({title, description, className, ...otherProps}) {
  return (
    <div className={cx("errorpage-root", className)} {...otherProps}>
      <div className="logo">
        <img src={logo}/>
      </div>
      <div className="errorpage">
        <div className="err-img"></div>
        <p className="title">{ title }</p>
        <p className="description">{ description }</p>
      </div>
    </div>
  )
}
export default Error;
